import React from 'react';
import { Route, useHistory } from 'react-router-dom';
import { handleRouteAccess } from '../../helpers/RouteHelpers';
import { isInteger } from '../../helpers/validators';
import { ROUTES } from '../../constants/routes/routes';

const ProtectedRoute = ({ path, isPageEnabled, action, component }) => {
    const Component = component;
    const history = useHistory();

    const renderedComponent = handleRouteAccess({
        Component,
        isPageEnabled,
        history,
        action,
    });
    return (
        <Route
            exact
            path={path}
            render={({ match }) => {
                const id = match?.params?.id;
                if (id) {
                    if (isInteger(id)) {
                        return renderedComponent;
                    }
                    else history.push(ROUTES.CLIENTS.BASE);
                }
                else return renderedComponent;
            }}
        />
    );
};

export default ProtectedRoute;
